import { createAction } from '@reduxjs/toolkit';

export const closeModal = createAction('betslip/ui/closeModal');
export const setFullScreenOff = createAction('betslip/ui/setFullScreenOff');
export const triggerMaxSelectionsModal = createAction('betslip/ui/triggerMaxSelectionsModal');
